import { CustomMidwayIdentityClient } from './CustomMidwayIdentityClient';

export default class CustomMidwayClient {
  client = {};
  constructor(config) {
    if (config) {
      this.client = new CustomMidwayIdentityClient(config);
    }
  }

  async fetch(options) {
    return this.client.request(options);
  }

  get(url) {
    return this.fetch({
      method: 'GET',
      url: url,
    });
  }

  post(url, payload) {
    return this.fetch({
      method: 'POST',
      url: url,
      data: payload,
    });
  }

  put(url, payload) {
    return this.fetch({
      method: 'PUT',
      url: url,
      data: payload,
    });
  }

  delete(url) {
    return this.fetch({
      method: 'DELETE',
      url: url,
    });
  }

  patch(url, payload) {
    return this.fetch({
      method: 'PATCH',
      url: url,
      data: payload,
    });
  }
}



// WEBPACK FOOTER //
// ./src/client/CustomMidwayClient.jsx